import { createAction, props } from "@ngrx/store";
import { ICreateWearingPartCategoryRequest, IUpdateWearingPartCategoryRequest, IWearingPartCategory } from "src/app/devices/models/wearing-part-categories";

// Get Wearing Part Categories
export const getWearingPartCategories = createAction(
    '[WearingPartCategories] Get Wearing Part Categories'
);

export const getWearingPartCategoriesSuccess = createAction(
    '[WearingPartCategories] Get Wearing Part Categories success', 
    props<{ wearingPartCategories: IWearingPartCategory[] }>()
);

export const getWearingPartCategoriesFailure = createAction(
    '[WearingPartCategories] Get Wearing Part Categories failure',
    props<{error: string}>()
);

// Create Wearing Part Category
export const createWearingPartCategory = createAction(
    '[WearingPartCategories] Create Wearing Part Category',
    props<{ wearingPartCategory: ICreateWearingPartCategoryRequest }>()
);

export const createWearingPartCategorySuccess = createAction(
    '[WearingPartCategories] Create Wearing Part Category success',
    props<{ wearingPartCategory: IWearingPartCategory }>()
);

export const createWearingPartCategoryFailure = createAction(
    '[WearingPartCategories] Create Wearing Part Category failure',
    props<{error: string}>()
);

// Update Wearing Part Category
export const updateWearingPartCategory = createAction(
    '[WearingPartCategories] Update Wearing Part Category',
    props<{ wearingPartCategory: IUpdateWearingPartCategoryRequest }>()
);

export const updateWearingPartCategorySuccess = createAction(
    '[WearingPartCategories] Update Wearing Part Category success',
    props<{ wearingPartCategory: IWearingPartCategory }>()
);

export const updateWearingPartCategoryFailure = createAction(
    '[WearingPartCategories] Update Wearing Part Category failure',
    props<{error: string}>()
);

// Delete Wearing Part Category
export const deleteWearingPartCategory = createAction(
    '[WearingPartCategories] Delete Wearing Part Category',
    props<{id: string}>()
);

export const deleteWearingPartCategorySuccess = createAction(
    '[WearingPartCategories] Delete Wearing Part Category success',
    props<{id: string}>()
);

export const deleteWearingPartCategoryFailure = createAction(
    '[WearingPartCategories] Delete Wearing Part Category failure',
    props<{error: string}>()
);